export const headingTriangle =
  "https://static.igem.wiki/teams/4380/wiki/agenda/agenda-triangle-desktop.svg"

export const headingTriangleWhite =
  "https://static.igem.wiki/teams/4380/wiki/agenda/headingtrianglewhite.svg"

export const closeIcon =
  "https://static.igem.wiki/teams/4380/wiki/agenda/closeicon.svg"

export const listItemTriangle =
  "https://static.igem.wiki/teams/4380/wiki/list/listitemtriangle.svg"
